import { render, staticRenderFns } from "./Highliter.vue?vue&type=template&id=1f4d4fdd&scoped=true"
import script from "./Highliter.vue?vue&type=script&lang=js"
export * from "./Highliter.vue?vue&type=script&lang=js"
import style0 from "./Highliter.vue?vue&type=style&index=0&id=1f4d4fdd&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f4d4fdd",
  null
  
)

export default component.exports